import {
    Button,
    DateRangeField,
    Form,
    FormFooter,
    FormSection,
    Page,
    toast
} from '@7shifts/sous-chef';
import { getUsersSyntheticReport } from 'api/reportsApi';
import { useFormik } from 'formik';
import { __ } from 'i18n/translate';
import UserSelectField from 'sharedComponents/UserSelectField';
import { downloadCSV } from 'utils/csv';
import { dateYearMonthDay } from 'utils/date';

type FormData = {
    date: { start: Date; end: Date };
    user: { key: string; value: string } | undefined;
};

const UsersSyntheticPage = () => {
    const formik = useFormik<FormData>({
        initialValues: {
            date: {
                start: new Date(),
                end: new Date()
            },
            user: undefined
        },
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            getUsersSyntheticReport(
                dateYearMonthDay(values.date.start),
                dateYearMonthDay(values.date.end),
                values.user ? +values.user.value : undefined
            )
                .then((data) => {
                    downloadCSV(data, 'users-synthetic.csv');
                })
                .catch(() => {
                    toast('Something went wrong', 'danger');
                })
                .finally(() => formik.setSubmitting(false));
        }
    });

    return (
        <Page
            breadcrumbs={__('main.reports')}
            title={__('reportsPage.reportUsersSynthetic')}
            subtitle={__('reportsPage.reportUsersSyntheticDescription')}
        >
            <Form formik={formik}>
                <FormSection as="card">
                    <DateRangeField
                        name="date"
                        label="Período"
                        format="dd/MM/yyyy"
                        disabledDays={{
                            before: new Date(
                                '2025-04-09 10:00:00'
                            ) /* data de implementacao do recurso */,
                            after: new Date()
                        }}
                    />
                    <UserSelectField
                        name="user"
                        placeholder={__('dashboardPage.allUsers')}
                        label="Usuário"
                        onChange={(userOption) =>
                            formik.setFieldValue('user', userOption)
                        }
                    />
                </FormSection>
                <FormFooter
                    actions={{
                        primary: (
                            <Button type="submit" loading={formik.isSubmitting}>
                                {__('main.downloadCSV')}
                            </Button>
                        )
                    }}
                />
            </Form>
        </Page>
    );
};

export default UsersSyntheticPage;
